import React, { useEffect, useRef } from 'react';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import { ColumnChart } from '../../Reports/templates/BarAndColumnCharts';
import MetricCard from '../MetricCard';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getPublishedUsersChartConfig from './utils';
import { exportEventName } from '.';
import ChrComparison from '../../Reports/templates/ChrComparison';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';

const Body = (props) => {
  const { metrics } = props;
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();

  const totalPublishedUsersAlongWithDualRole = getMetricDataFromArray(metrics, MetricUId.TOTAL_PUBLISHED_USERS_ALONG_WITH_DUAL_ROLE);
  const previousPeriod = totalPublishedUsersAlongWithDualRole.data.previousPeriod;

  return (
    <WidgetBodyWrapper { ...props } additionalClassNames="max-height-500" >
      <div className='d-flex flex-column' ref={ chartWrapperReference }>
        <MetricCard
          value={ totalPublishedUsersAlongWithDualRole.data.value }
          url={ totalPublishedUsersAlongWithDualRole.url }
          alert={ totalPublishedUsersAlongWithDualRole.data.alert }
          title={ totalPublishedUsersAlongWithDualRole.shortName }
          className="mb-4"
          helpText={ totalPublishedUsersAlongWithDualRole.shortHelpText }
          eventDetails={ totalPublishedUsersAlongWithDualRole.eventDetails }
          subtitle={ previousPeriod && <ChrComparison
            changeSentiment={ previousPeriod.insights.sentiment }
            changeValue={ previousPeriod.insights.changeValue }
            changeDirection={ previousPeriod.insights.direction }
            periodOne={ { dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value: totalPublishedUsersAlongWithDualRole.data.value } }
            periodTwo={ { dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value } }
          /> }
        />
        <div className="align-self-stretch">
          <ColumnChart
            chartOptions={ getPublishedUsersChartConfig(totalPublishedUsersAlongWithDualRole.subMetrics) }
            configs={ { export: true, exportEventName } }
            callbackFn={ chartCallbackFunction }
          />
        </div>
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;
